import { Box, Tab, Tabs } from "@mui/material";
import {
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
  useState,
} from "react";
import { Country, CountryKey, TranslationElement, TranslationEntity } from "../../../utils/models/Common.model";
import { FormTranslation } from "./FormTranslation";

export function TabsTranslation({
  langs,
  translations,
  setTranslations,
}: {
  langs: CountryKey[];
  translations: TranslationEntity["translations"];
  setTranslations: Dispatch<SetStateAction<TranslationEntity["translations"]>>;
}) {
  const [value, setValue] = useState<undefined | CountryKey>(undefined);
  useEffect(() => {
    if (value === undefined) {
      setValue(langs[0]);
    }
  }, [langs, value]);
  const setTranslation = useCallback(
    (key: CountryKey, translation: TranslationElement) => {
      setTranslations((value) => ({
        ...value,
        [key]: translation,
      }));
    },
    [setTranslations]
  );

  return (
    <>
      {langs.length > 0 && (
        <div>
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={value || false}
                onChange={(_, value) => setValue(value)}
                aria-label="basic tabs example"
              >
                {langs.map((key) => (
                  <Tab key={key} label={Country[key]} value={key} />
                ))}
              </Tabs>
            </Box>
            {langs.map((key) => (
              <div role="tabpanel" key={key} hidden={value !== key}>
                <FormTranslation
                  translation={translations[key]}
                  lang={key}
                  onChange={setTranslation}
                />
              </div>
            ))}
          </Box>
        </div>
      )}
    </>
  );
}
